<av-menu-item
  [attr.aria-label]="'Schedule a video call' | translate"
  icon="calendar-time"
  (select)="callbackRequest()"
>
  <span translate>Schedule a video call</span>
</av-menu-item>
